import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_storage_all: FaireCategoryEntity = {
  token: "cat_storage-all",
  type: "category",
  name: "All storage & organization",
  level: 3,
  parentToken: "cat_home-decor-storage",
  href: "/category/home-decor/storage-organization",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
